exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3JymXzzg8lprTDZp3G66HK{cursor:pointer;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"link": "_3JymXzzg8lprTDZp3G66HK"
};